declare global {
  interface Array<T> {
    first: () => T;
    last: () => T;
    isEmpty: () => boolean;
    sum: () => number;
  }
}

const load = () => {
  Array.prototype.first = function () {
    return this[0];
  };

  Array.prototype.last = function () {
    return this[this.length - 1];
  };

  Array.prototype.isEmpty = function () {
    return this.length === 0;
  };

  Array.prototype.sum = function () {
    return this.filter((number) => !isNaN(number)).reduce((acc, value) => acc + value, 0);
  };
};

export default load();
